import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'

export default {
  state: {
    groups: {},
    ownGroups: [],
  },

  mutations: {
    ADD_OWN_GROUPS (state, ownGroups) {
      state.ownGroups = ownGroups
    },
  },

  actions: {
    getGroups ({ commit }, courseId) {
      return api.getGroups(courseId).then(storeAllEntities(commit))
    },
    getOwnGroups ({ commit, state }, courseId) {
      return api.getOwnGroups(courseId).then(data => {
        commit('ADD_OWN_GROUPS', data.data.ownGroupsArray)
      })
    },
    updateOwnGroups ({ commit, state }, { courseId, groupIds }) {
      return api.updateOwnGroups(courseId, groupIds).then(data => {
        commit('ADD_OWN_GROUPS', data.data.ownGroupsArray)
      })
    },
  },

  getters: {},
}
